import { useMemo } from 'react'
import { KeplerTableField, MapDatasetEnriched, TableWidget } from 'features/builder'
import { ALL_FIELD_TYPES } from '@carto/kepler.gl/constants'
import { getKeplerFieldFromDatasetScheme, isStaticSpatialIndexDataset } from 'features/builder/state/builderSliceUtils'

function isFieldAllowed(field) {
  return field.type !== ALL_FIELD_TYPES.geojson && !field.artificial
}

export function isTableWidgetValid(widget: TableWidget, { source }: { source: MapDatasetEnriched }): boolean {
  return widget.columns.every((column) => source.fields?.some((f) => f.id === column.field))
}

function useWidgetTableModel({ source }) {
  const allowedFields: KeplerTableField[] = useMemo(() => {
    const result = [...source.fields]

    if (isStaticSpatialIndexDataset(source)) {
      result.unshift(getKeplerFieldFromDatasetScheme(source))
    }

    return result.filter(isFieldAllowed)
  }, [source])

  const initialFields = useMemo(() => {
    const fields = allowedFields.slice(0, 3)

    return fields.map((field) => ({ field: field.name }))
  }, [allowedFields])

  const validateWidget = (widget: TableWidget) => {
    widget.isValid = true

    if (widget.columns) {
      widget.columns = widget.columns.filter(({ field }) => {
        const sourceField = allowedFields.find((f) => f.name === field)
        return sourceField && isFieldAllowed(sourceField)
      })
    }

    if (!widget.columns || widget.columns.length === 0) {
      widget.isValid = false
    }
  }

  const isWidgetAvailable = allowedFields.length > 0

  return {
    validateWidget,
    isWidgetAvailable,
    allowedFields,
    initialFields
  }
}

export default useWidgetTableModel
